<template>
    <div class="login">
        <form class="form-horizontal" role="form">
            <div class="col-sm-12">
                <button class="btn btn-default btn-lg btn-block" @click="login">登录</button>
            </div>
        </form>
    </div>
</template>
<style scoped>
    .login {
        width: 100%;
        height: 100%;
        background: url(/static/login.jpg);
        position: relative;
    }

    .form-horizontal {
        width: 400px;
        position: absolute;
        top: 50%;
        left: 50%;
        margin: -50px 0 0 -200px;
        padding: 30px;
    }
</style>
<script>
  export default {
    mounted: function () {
      // wode
      // localStorage.setItem('access_t  oken','eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpYXQiOjE2MjM5Nzg2NDksIm5iZiI6MTYyMzk3ODY0OSwianRpIjoiMDMwNjExYmYtOTU4NC00NWQxLWIyMzItOTM3ZGEyOWU0MGE4IiwiZXhwIjoxNjI0NTgzNDQ5LCJpZGVudGl0eSI6Im9yNHpYMDZnUlNNdnZmRlFnM0dhV3hUdXBtWjQiLCJmcmVzaCI6ZmFsc2UsInR5cGUiOiJhY2Nlc3MiLCJ1c2VyX2NsYWltcyI6eyJhY2Nlc3NfdG9rZW4iOiI0Nl9KdVVqVlcwZExOeW9VUS1SWm1WR0xrRkJzdlhtc1ZNclNuNTcwdFRacldiZ19RR1ZiSnlKamlaRlhTU0ttMFBhX0paQ0htWV9PRTl0RHNldzRMQjBqdmQzUmR0bjc4R1Q2bFJ2TXEycnBXbyIsImV4cGlyZXNfaW4iOjcyMDAsInJlZnJlc2hfdG9rZW4iOiI0Nl9VZjE4a0FjVzVfc29maDFLMEo0cmdEQW1FQzZvdXlycTNDLUZlMF9DWFpNQVlRbEZuVmhqblEtcEtiT0lacFFyY3drVDdodXIxQ0VkNHVDQnNmdFdrQXVocGdxZkRMWjUxY0xTR2tDY1gtMCIsIm9wZW5pZCI6Im83NWhlMUt3eC1kLWJobkZGS0VOWmRmLUltVG8iLCJzY29wZSI6InNuc2FwaV9sb2dpbiIsInVuaW9uaWQiOiJvcjR6WDA2Z1JTTXZ2ZkZRZzNHYVd4VHVwbVo0In19.kaUQ9em4higv7r81YVFtBBD0Dfr_wZ9s2zBrMA-d1JY');
      // 测试账号
      // localStorage.setItem('access_token','eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpYXQiOjE2MDc1MDQ5NTUsIm5iZiI6MTYwNzUwNDk1NSwianRpIjoiNGQ2YmE3ODMtODc2MC00ZGUxLWFiYTUtMTA1Y2NiNWZjN2U2IiwiZXhwIjoxNjA4MTA5NzU1LCJpZGVudGl0eSI6Im9yNHpYMDZnUlNNdnZmRlFnM0dhV3hUdXBtWjQiLCJmcmVzaCI6ZmFsc2UsInR5cGUiOiJhY2Nlc3MiLCJ1c2VyX2NsYWltcyI6eyJhY2Nlc3NfdG9rZW4iOiI0MF9fZWZOUkF4czkxYU9wUGNJU053bDRBR0ctcXAyOVo3Yi1OeTZXSVJZYVBjTnFZNV9aNVVMNXlLY3BvNl9EeG5uRktYd1Rkb2w0elNmWXRGX0RKMG1TWVJadm9qODU4YUZZcGZ0VEJub1ZRRSIsImV4cGlyZXNfaW4iOjcyMDAsInJlZnJlc2hfdG9rZW4iOiI0MF9hbzd2SGR0QkhUWHhNS2Faa0NsUDE4S0xRWTF0X1JOc2Z1eVkwSW9GMmo0Q1FnUVJvYV9JREs5QXpqNlBXQmdCQm5rbHJkUndHVjFVNWluQ0pVUzJua19JZ1hXdmktUnk4aW0tZVhQa1RzQSIsIm9wZW5pZCI6Im83NWhlMUt3eC1kLWJobkZGS0VOWmRmLUltVG8iLCJzY29wZSI6InNuc2FwaV9sb2dpbiIsInVuaW9uaWQiOiJvcjR6WDA2Z1JTTXZ2ZkZRZzNHYVd4VHVwbVo0In19.ezPE2nKSkJYUGFGqqQ7SvJ8gY37uJA-i2tkuO7CzNbI')

    },
    methods: {
      login: function () {
        console.log('___Login.vue 登录按钮进行登录')
        window.location.href = this.global.loginurl
      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/views/login/login.vue